import React from 'react'
import { motion } from 'framer-motion'

interface EnhancedSlideIndicatorProps {
  currentSlide: number
  totalSlides: number
  onGoToSlide: (index: number) => void
  slides: Array<{ title?: string; type?: string }>
}

const EnhancedSlideIndicator: React.FC<EnhancedSlideIndicatorProps> = ({
  currentSlide,
  totalSlides,
  onGoToSlide,
  slides: _slides
}) => {
  // Minimal desktop indicator: no expanded state or slide-type helpers

  return (
    <>
      {/* Mobile: Bottom slide indicator */}
      <div className="md:hidden fixed bottom-20 left-4 right-4 z-40">
        <div className="flex justify-center gap-1">
          {Array.from({ length: totalSlides }, (_, index) => (
            <motion.button
              key={index}
              whileHover={{ scale: 1.2 }}
              whileTap={{ scale: 0.9 }}
              onClick={() => onGoToSlide(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 ${
                index === currentSlide
                  ? 'bg-bible-gold scale-125 shadow-lg shadow-bible-gold/50'
                  : 'bg-slate-600 hover:bg-slate-500'
              }`}
              title={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>

      {/* Desktop indicator removed intentionally (navigation controls handle slides) */}
    </>
  )
}

export default EnhancedSlideIndicator
